import React, { useState, useEffect, useCallback, useContext } from "react"
import axios from "axios"
import {
  FlexColumnContainer,
  StyledTextField,
  FlexRowContainer,
} from "components/AllHelpComponents"

import { useNavigate } from "react-router-dom"
import { useForm } from "react-hook-form"
import { baseURL, creditCardInitialData } from "constants/constants"
import { Box } from "@mui/system"
import { StyledButton } from "components/StyledButton"
import { useNavigator } from "hooks/useNavigator"
import DialogComponent from "components/DialogComponent"
import { CartContext } from "App"
import applePay from "images/icons/applePay.png"
import googlePay from "images/icons/googlePay.png"

import { useTranslation } from "react-i18next"
import { LoadingOverlay } from "components/LoadingOverlay"
import { fixScrollTop } from "helpers/scrollSaver"
import { Footer } from "components/Footer"
import { BigButton } from "components"
import { Button, TextField } from "@mui/material"
import CreditCardIcon from "@mui/icons-material/CreditCard"
import PaymentsIcon from "@mui/icons-material/Payments"

export const Payments = () => {
  const { t } = useTranslation()
  const tele = window.Telegram.WebApp

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [formOpenCreditCard, setFormOpenCreditCard] = useState(false)

  const [dialogOpen, setDialogOpen] = useState(false)
  // const [tempErrors, setTempErrors] = useState({})

  const [dialogTitle, setDialogTitle] = useState(t("Success"))
  const [dialogText, setDialogText] = useState(t("Order successfully created!"))

  const [orderCreated, setOrderCreated] = useState(false) // Добавленное состояние

  const { env } = useNavigator()
  const navigate = useNavigate()

  const {
    queryId,
    cartItems,
    comment,
    customerName,
    totalPrice,
    address,
    telephone,
    optionDelivery,
    user,
    settings,
    setCartItems,
    restaurant_id,
  } = useContext(CartContext)

  const state = {
    queryId,
    cartItems,
    comment,
    totalPrice,
    address,
    telephone,
    optionDelivery,

    user_id: user?.id || 0,
    user_name: user?.username || "",
    customer_name: customerName || "",
    // order_date: new Date(),
  }

  console.log("state_CreditCard", state)

  const handleCloseDialog = () => {
    setDialogOpen(false)
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
    // formState
    reset,
    setError,
    setValue,
  } = useForm()

  // const { register, handleSubmit, formState } = useForm(formOptions)

  // const validateFields = (data) => {
  //   const errors = {}

  //   if (!data.cardNumber || !/^\d{16}$/.test(data.cardNumber)) {
  //     setError("cardNumber", {
  //       type: "manual",
  //       message: t("incorrectCardNumber"),
  //     })
  //     errors.cardNumber = t("incorrectCardNumber")
  //   }

  //   if (!data.expiryDate || !/^(0[1-9]|1[0-2])\/\d{2}$/.test(data.expiryDate)) {
  //     setError("expiryDate", {
  //       type: "manual",
  //       message: t("incorrectExpiryDate"),
  //     })
  //     errors.expiryDate = t("incorrectExpiryDate")
  //   }

  //   if (!data.cvv || !/^\d{3,4}$/.test(data.cvv)) {
  //     setError("cvv", {
  //       type: "manual",
  //       message: t("incorrectCvvCode"),
  //     })
  //     errors.cvv = t("incorrectCvvCode")
  //   }

  //   if (data.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
  //     setError("email", {
  //       type: "manual",
  //       message: t("incorrectEmail"),
  //     })
  //     errors.email = t("incorrectEmail")
  //   }
  //   return errors
  // }

  //======================================================================

  async function payCreditCard(dataPay) {
    try {
      const response = await axios.post(baseURL + "/pay_credit_card", dataPay)
      console.log('Запрос "pay_credit_card" успешно выполнен')
    } catch (error) {
      console.error('Ошибка при выполнении запроса "pay_credit_card":', error)
      return
    }
  }

  //========================================

  async function createOrderDB(dataPay) {
    console.log("dataPay :>> ", dataPay)
    try {
      const response = await axios.post(baseURL + "/create_order_db", dataPay)
      console.log('Запрос "create_order_db" успешно выполнен')
      setDialogOpen(true) // Устанавливаем состояние при успешном выполнении
      setCartItems([])
    } catch (error) {
      console.error('Ошибка при выполнении запроса "create_order_db":', error)
      return
    }
  }

  async function sendSMSTele(dataPay) {
    try {
      const response = await axios.post(baseURL + "/send_sms_tele", dataPay)
      console.log('Запрос "send_sms_tele" успешно выполнен')
    } catch (error) {
      console.error('Ошибка при выполнении запроса "send_sms_tele":', error)
      return
    }
  }

  //======================================================================
  const handlePayment = async (paymentMethod) => {
    setIsSubmitting(true)

    try {
      const cartItemsWithoutImage = cartItems.map((item) => {
        const { image, ...rest } = item
        return rest
      })

      const dataPay = {
        ...state,
        paymentMethod,
        cartItems: cartItemsWithoutImage,
        restaurantId: restaurant_id,
      }

      await createOrderDB(dataPay)
      await sendSMSTele(dataPay)

      if (paymentMethod === "card") {
        await payCreditCard(dataPay)
      }
    } catch (error) {
      console.error("Error:", error)
    } finally {
      setIsSubmitting(false)
    }
  }

  // Использование функции handlePayment для всех типов оплаты

  const onCreditCard = () => {
    handlePayment("card")
  }

  const onApplePay = () => {
    handlePayment("onApplePay")
  }

  const onGooglePay = () => {
    handlePayment("onGooglePay")
  }

  const onOrderToWaiter = () => {
    handlePayment("onOrderToWaiter")
  }

  // useEffect(() => {
  //   setValue("cardNumber", creditCardInitialData.cardNumber);
  //   setValue("expiryDate", creditCardInitialData.expiryDate);
  //   setValue("cvv", creditCardInitialData.cvv);
  //   setValue("email", creditCardInitialData.email);
  // }, [setValue]);

  const handleFillForm = () => {
    setValue("cardNumber", creditCardInitialData.cardNumber, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    })
    setValue("expiryDate", creditCardInitialData.expiryDate, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    })
    setValue("cvv", creditCardInitialData.cvv, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    })
    setValue("email", creditCardInitialData.email, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    })
  }

  useEffect(() => {
    console.log("errors444", JSON.stringify(errors, null, 2))
  }, [errors])

  useEffect(() => {
    fixScrollTop()
  }, [])

  // const validationSchema = Yup.object().shape({
  //   firstName: Yup.string().required('First Name is required'),
  //   lastName: Yup.string().required('Last Name is required'),
  //   email: Yup.string()
  //     .matches(mailRegEx, 'Mail is not valid')
  //     .required('email is required'),
  //   password: Yup.string()
  //     .required('Password is required')
  //     .min(8, 'Password must be at least 8 characters'),

  //   // id: Yup.string()
  //   //   .test('is-valid-id', 'ID is not valid', (value) =>
  //   //     is_israeli_id_number(value)
  //   //   )
  //   //   .required('Passport Number is required'),

  //   id: Yup.string().when('environment', {
  //     termsAndConditions: Yup.boolean()
  //       .oneOf([true], 'You must accept the terms and conditions')
  //       .required('You must accept the terms and conditions'),

  //     is: 'production',
  //     then: Yup.string().test('is-valid-id', 'ID is not valid', (value) =>
  //       is_israeli_id_number(value)
  //     ),
  //     otherwise: Yup.string(),
  //   }),

  //   phoneNumber: Yup.string()
  //     .matches(phoneRegExp, 'Phone number is not valid')
  //     .required('Phone Number is required'),
  //   countryCode: Yup.string().required('Country Code is required'),
  //   city: Yup.string().required('City is required'),
  //   address: Yup.string().required('Address is required'),
  // })

  // const formOptions = { resolver: yupResolver(validationSchema) }
  // const { errors } = formState

  const onShowCreditCard = () => {
    setFormOpenCreditCard(formOpenCreditCard ? false : true)
  }
  const onBack = () => {
    navigate(-1)
    // navigate("/products")
  }

  console.log("settings", settings)
  return (
    <>
      {/* {console.log("isSubmitting", isSubmitting)} */}
      {isSubmitting ? <LoadingOverlay /> : null}

      {settings?.showCreditCardButton ? (
        <StyledButton onClick={onShowCreditCard} variant="contained" startIcon={<CreditCardIcon />}>
          {t("Credit Card")}
        </StyledButton>
      ) : (
        <></>
      )}

      {formOpenCreditCard && (
        <FlexColumnContainer
          sx={{
            pt: "20px",
            backgroundColor: "white",
            gap: 2,
            color: "black",
            // height: "100vh",
            padding: "20px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h1 className="title">{t("cardPayment")}</h1>

          <Box component="form" onSubmit={handleSubmit(onCreditCard)}>
            <StyledTextField
              {...register("cardNumber", {
                required: t("cardNumber is required"),
              })}
              label={t("cardNumberLabel")}
              error={!!errors.cardNumber}
              helperText={errors.cardNumber?.message}
              sx={{ width: "100%", mb: 2 }}
              InputLabelProps={{ shrink: true }}
            />

            <Box sx={{ display: "flex", gap: "16px", pb: 2 }}>
              <StyledTextField
                {...register("expiryDate", {
                  required: t("expiryDate is required"),
                })}
                label={t("expiryDateLabel")}
                error={!!errors.expiryDate}
                helperText={errors.expiryDate?.message}
                sx={{ flex: 1, mr: 2 }}
                InputLabelProps={{ shrink: true }}
              />
              <StyledTextField
                {...register("cvv", { required: t("cvvCode is required") })}
                label={t("cvvCodeLabel")}
                error={!!errors.cvv}
                helperText={errors.cvv?.message}
                sx={{ flex: 1 }}
                InputLabelProps={{ shrink: true }}
              />
            </Box>
            <StyledTextField
              {...register("email", { required: t("email is required") })}
              label={t("emailLabel")}
              error={!!errors.email}
              helperText={errors.email?.message}
              sx={{ width: "100%", mb: 2 }}
              InputLabelProps={{ shrink: true }}
            />

            <FlexRowContainer>
              <Button type="submit" variant="contained">
                {t("submitButton")}{" "}
              </Button>
              <Button variant="outlined" onClick={handleFillForm}>
                {t("Fill Form")}
              </Button>
            </FlexRowContainer>

            {/* {env === "browser" && (
              <StyledButton type="submit" variant="contained">
                {t("submitButton")}{" "}
              </StyledButton>
            )} */}
          </Box>
        </FlexColumnContainer>
      )}

      {settings?.showApplePayButton ? (
        <StyledButton onClick={onApplePay} variant="contained">
          {t("Buy with")} <img src={applePay} alt="applePay" /> Pay
        </StyledButton>
      ) : (
        <></>
      )}

      {settings?.showGooglePayButton ? (
        <StyledButton onClick={onGooglePay} variant="contained">
          {t("Buy with")} <img src={googlePay} alt="googlePay" /> Pay
        </StyledButton>
      ) : (
        <></>
      )}

      {settings?.showOrderButton ? (
        <StyledButton onClick={onOrderToWaiter} variant="contained" startIcon={<PaymentsIcon />}>
          {t("cash")}
        </StyledButton>
      ) : (
        <></>
      )}

      <DialogComponent
        dialogTitle={dialogTitle}
        text={dialogText}
        buttonRight={t("ok")}
        open={dialogOpen}
        onClose={handleCloseDialog}
      />

      <Footer>
        <BigButton onClick={onBack}>{`${t("Back")}  `}</BigButton>
      </Footer>
    </>
  )
}
